import api from './client';

export interface User {
  id: number;
  email: string;
  name: string;
  avatar_url: string;
  is_active: boolean;
  is_staff: boolean;
  is_superuser: boolean;
  mfa_enabled: boolean;
}

export interface AuthResponse {
  user: User;
}

export interface MfaChallengeResponse {
  mfa_required: true;
  pending_token: string;
}

export const login = async (email: string, password: string): Promise<AuthResponse | MfaChallengeResponse> => {
  const res = await api.post<AuthResponse | MfaChallengeResponse>('/auth/login/', { email, password });
  return res.data;
};

export const verifyOtp = async (pending_token: string, code: string): Promise<AuthResponse> => {
  const res = await api.post<AuthResponse>('/auth/verify-otp/', { pending_token, code });
  return res.data;
};

export const register = async (email: string, password: string, password_confirm: string): Promise<AuthResponse> => {
  const res = await api.post<AuthResponse>('/auth/register/', { email, password, password_confirm });
  return res.data;
};

export const logout = async () => {
  await api.post('/auth/logout/', {}).catch(() => {});
};

export const getMe = async (): Promise<User> => {
  const res = await api.get<User>('/auth/me/');
  return res.data;
};

export const updateProfile = async (data: Partial<Pick<User, 'name' | 'avatar_url' | 'mfa_enabled'>>): Promise<User> => {
  const res = await api.patch<User>('/auth/me/', data);
  return res.data;
};

export const changePassword = async (current_password: string, new_password: string, new_password_confirm: string) => {
  const res = await api.post('/auth/change-password/', { current_password, new_password, new_password_confirm });
  return res.data;
};

export const forgotPassword = async (email: string) => {
  const res = await api.post('/auth/forgot-password/', { email });
  return res.data;
};

export const resetPassword = async (uid: string, token: string, new_password: string, new_password_confirm: string) => {
  const res = await api.post('/auth/reset-password/', { uid, token, new_password, new_password_confirm });
  return res.data;
};

export interface PublicConfig {
  mfa_enabled: boolean;
}

/** Feature flags safe to read before login (e.g. whether MFA is available at all org-wide). */
export const getPublicConfig = async (): Promise<PublicConfig> => {
  const res = await api.get<PublicConfig>('/config/');
  return res.data;
};
